// ------
// Mobile menu toggle
// ------

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
  toggleBodyScrollLock(toggle);
};

attachEvent('.mobile-hamburger', 'click', () => {
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleMenuClass(!isOpen);
});

// ------
// Search
// ------
const searchInput = document.querySelector('.header-search__input-field');
const headerSearch = document.querySelector('.header-search');
const resetBtn = document.querySelector('.header-search__reset');
const searchField = document.querySelector('#searchTerm');
const searchForm = document.querySelector('.header-search__form');
const searchResultWrapper = document.querySelector('.header-search__wrapper');
const searchTrigger = document.querySelector('.header-main__search-trigger');

if (searchInput) {
  const toggleSearchClass = (toggle) => {
    document.body.classList.toggle('is-open-search', toggle);
    toggleMenuClass(false);
    toggleBodyScrollLock(toggle);
    toggleHideClass(searchResultWrapper, !toggle);

    searchInput[toggle ? 'focus' : 'blur']();
  };

  const resetSearchHtml = () => {
    searchField.value = '';
    searchInput.blur();
    headerSearch.classList.remove('has-value');
    searchForm.reset();
    searchHeaderPosts({ value: '////' });
    toggleSearchClass(false);
    updateFirstActive();
  };

  attachEvent('.header-search__close, [data-close-search]', 'click', () => {
    document.body.classList.remove('is-open-search');
    resetSearchHtml();
  });

  searchInput.addEventListener('input', () => {
    headerSearch.classList.toggle('has-value', !!searchField.value.trim());
  });

  resetBtn.addEventListener('click', () => {
    searchField.value = '';
    searchInput.blur();
    headerSearch.classList.remove('has-value');
    searchForm.reset();
    searchHeaderPosts({ value: '////' });
  });

  searchTrigger.addEventListener('click', () => {
    toggleSearchClass(true);
  });

  searchField.addEventListener('focus', () => {
    toggleSearchClass(true);
  });

  // searchField.addEventListener('blur', () => {
  //   if (!searchField.value.trim()) {
  //     resetSearchHtml();
  //   }
  // });

  onKeydown('escape', () => {
    resetSearchHtml();
  });

  let lastSearchTerm = '';

  // ------
  // Search - Result Ajax
  // ------
  const searchHeaderPosts = (search, key = '') => {
    if (search.value === lastSearchTerm) {
      return;
    }
    lastSearchTerm = search.value;
    const searchResultLinks = headerSearch.querySelector('.header-search__links-wrapper');
    const searchResultProducts = headerSearch.querySelector('.header-search__products-wrapper');
    const searchResultRecipes = headerSearch.querySelector('.header-search__recipes-wrapper');
    const searchResultNotFound = headerSearch.querySelector('.header-search__not-found-wrapper');

    if (search.value && search.value !== '////') {
      axios
        .post(
          localData.apiURL,
          {
            action: 'searchPostsHeader',
            keyword: search.value,
            lang: localData.lang,
            keyboardKey: key,
          },
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        )
        .then((response) => {
          [searchResultProducts, searchResultRecipes, searchResultNotFound].forEach((el) => {
            el.innerHTML = '';
          });

          if (response.data.html_products) {
            searchResultProducts.innerHTML = response.data.html_products;
          }

          if (response.data.html_recipes) {
            searchResultRecipes.innerHTML = response.data.html_recipes;
          }

          if (!response.data.html_products && !response.data.html_recipes) {
            searchResultNotFound.classList.remove('hide');
            searchResultLinks.classList.remove('hide');

            searchResultNotFound.innerHTML = `<div class='header-search__not-found'> <div class='container'> <div data-component='at-title' class='title  title--h4 '> <h2>${response.data.no_results_title}</h2> </div> <div class='header-search__not-found-text  d-flex-cc  text--gray-400'> ${response.data.no_results_found_text} </div> </div> </div>`;
          } else {
            searchResultLinks.classList.add('hide');
          }

          // eslint-disable-next-line no-unused-expressions
          initProductSlider();
          setupResponsiveSliders({
            sliderElements: productSlider,
            breakpoint: 767,
            initSlider: initProductSlider,
            mobileFallback: enableScrollbarSync,
            parentSelector: '[data-slider-parent]',
          });
        });
    } else {
      searchHeaderPosts({ value: '////' });
    }
    lastSearchTerm = search.value;
  };
  searchField.addEventListener(
    'keyup',
    debounce((e) => {
      if (e.key === 'Escape') {
        toggleSearchClass(false);
        return;
      }

      const value = searchField.value.trim();

      if (value.length >= 3) {
        searchHeaderPosts(searchField, e.key);
      }
    }, 200),
  );

  // ------
  // Search - click on result item
  // ------
  attachEvent('.header-search__results-repeater button.header-search__result', 'click', (ev) => {
    ev.preventDefault();
    if (ev.target.innerText) {
      const searchTerm = ev.target.closest('.header-search__result').innerText;
      searchHeaderPosts({ value: searchTerm });
      searchInput.focus();
      searchInput.value = searchTerm;
    }
  });
}
